let time = {
  setTime(fmt) {
    const time = new Date(fmt * 1000);
    const Y = time.getFullYear();
    const M = (time.getMonth() + 1).toString().padStart(2, "0");
    const D = time
      .getDate()
      .toString()
      .padStart(2, "0");
    const h = time
      .getHours()
      .toString()
      .padStart(2, "0");
    const m = time
      .getMinutes()
      .toString()
      .padStart(2, "0");
    const s = time
      .getSeconds()
      .toString()
      .padStart(2, "0");
    return `${Y}-${M}-${D} ${h}:${m}:${s}`;
  },
  setDate(fmt) {
    const time = new Date(fmt * 1000);
    const Y = time.getFullYear();
    const M = (time.getMonth() + 1).toString().padStart(2, "0");
    const D = time
      .getDate()
      .toString()
      .padStart(2, "0");
    return `${Y}-${M}-${D}`;
  },
  numZero(num) {
    let day = [];

    for (let i = 1; i <= num; i++) {
      let obj = {
        label: i
      };
      if (i < 10) {
        obj.value = "0" + i;
      } else {
        obj.value = i;
      }
      day.push(obj);
    }
    return day;
  },
  month: [
    {
      value: "01",
      label: "1"
    },
    {
      value: "02",
      label: "2"
    },
    {
      value: "03",
      label: "3"
    },
    {
      value: "04",
      label: "4"
    },
    {
      value: "05",
      label: "5"
    },
    {
      value: "06",
      label: "6"
    },
    {
      value: "07",
      label: "7"
    },
    {
      value: "08",
      label: "8"
    },
    {
      value: "09",
      label: "9"
    },
    {
      value: "10",
      label: "10"
    },
    {
      value: "11",
      label: "11"
    },
    {
      value: "12",
      label: "12"
    }
  ],
  day: [
    {
      value: "01",
      label: "1"
    },
    {
      value: "02",
      label: "2"
    },
    {
      value: "03",
      label: "3"
    },
    {
      value: "04",
      label: "4"
    },
    {
      value: "05",
      label: "5"
    },
    {
      value: "06",
      label: "6"
    },
    {
      value: "07",
      label: "7"
    },
    {
      value: "08",
      label: "8"
    },
    {
      value: "09",
      label: "9"
    },
    {
      value: "10",
      label: "10"
    },
    {
      value: "11",
      label: "11"
    },
    {
      value: "12",
      label: "12"
    }
  ],
  /**
   * [isDuringDate 比较当前时间是否在指定时间段内]
   * @author dongsir
   * @DateTime 2019-08-21
   * @version  1.0
   * @param    date   [beginDateStr] [开始时间]
   * @param    date   [endDateStr]   [结束时间]
   * @return   Boolean
   */
  isDuringDate: function(beginDateStr, endDateStr) {
    var curDate = new Date(),
      beginDate = new Date(beginDateStr),
      endDate = new Date(endDateStr);
    if (curDate >= beginDate && curDate <= endDate) {
      return 0;
    }
    if (curDate < beginDate) {
      return 1;
    }
    if (curDate > endDate) {
      return 2;
    }
  },
  //转换时间戳
  Time_stamp(time) {
    console.log(time);
    var dateTime = new Date(time);
    var time2 = dateTime.getTime() / 1000;
    return time2;
  },
  /*
   *@param s : 时间秒
   */
  secondsFormat(s) {
    var day = Math.floor(s / (24 * 3600)); // Math.floor()向下取整
    var hour = Math.floor((s - day * 24 * 3600) / 3600);
    var minute = Math.floor((s - day * 24 * 3600 - hour * 3600) / 60);
    var second = s - day * 24 * 3600 - hour * 3600 - minute * 60;
    return day + "天" + hour + "时" + minute + "分" + second + "秒";
  }
};

export default time;
